import { Gradient, GradientBackground } from '#app/components/ui/gradient.tsx'
import type { LoaderFunctionArgs, MetaFunction } from '@remix-run/node'
import { Outlet } from '@remix-run/react'
import Header from './components/header.tsx'
import Footer from './components/footer.tsx'
import { json } from '@remix-run/node'
import { prisma } from '#app/utils/db.server.ts'
import type { SEOPageType } from '#app/routes/dashboard+/settings+/seo+'

export async function loader({ request, params }: LoaderFunctionArgs) {
	// Get the current route from the URL
	const url = new URL(request.url)
	const path = url.pathname.slice(1) // Remove leading slash

	// Convert path to SEO page type (empty path = HOME)
	const page = (path || 'HOME').toUpperCase() as SEOPageType

	const seo = await prisma.sEOSettings.findUnique({
		where: { page },
	})

	return json({ seo, currentPage: page })
}

export const meta: MetaFunction<typeof loader> = ({
	data,
	matches,
	location,
}) => {
	const rootData = matches.find((match) => match.id === 'root')?.data as {
		generalSettings?: {
			website_name: string
			twitter_site: string
			twitter_creator: string
		}
		requestInfo?: { origin: string }
	}

	const title =
		data?.seo?.title ||
		rootData?.generalSettings?.website_name ||
		(data?.currentPage &&
			data?.currentPage.charAt(0) + data?.currentPage.slice(1).toLowerCase())

	const description = data?.seo?.description
	const fullUrl = location.search
		? `${rootData?.requestInfo?.origin}${location.pathname + location.search}`
		: `${rootData?.requestInfo?.origin}${location.pathname}`

	return [
		{ title },
		{ name: 'description', content: description },
		{ property: 'og:title', content: title },
		{ property: 'og:description', content: description },
		//{ property: "og:image", content: imageUrl },
		{ property: 'og:url', content: fullUrl },
		{ property: 'og:type', content: 'website' },
		{ property: 'twitter:card', content: 'summary_large_image' },
		{ property: 'twitter:title', content: title },
		{ property: 'twitter:description', content: description },
		//{ property: "twitter:image", content: imageUrl },

		// Conditional Twitter tags
		...(rootData?.generalSettings?.twitter_site
			? [
					{
						name: 'twitter:site',
						content: rootData.generalSettings.twitter_site,
					},
				]
			: []),
		...(rootData?.generalSettings?.twitter_creator
			? [
					{
						name: 'twitter:creator',
						content: rootData.generalSettings.twitter_creator,
					},
				]
			: []),
	]
}

export default function layout() {
	return (
		<>
			<div className="relative flex flex-col">
				<GradientBackground />
				{/* <Header /> */}
				<Outlet />
				{/* <Footer /> */}
			</div>
		</>
	)
}
